import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateMar = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / March`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFE29A)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFE29A)",
								stroke: "var(--sticker-dark,#B87C1F)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7383
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M7.9861 12.8962 L7.9861 7.2961 L9.49 7.2961 L10.858 10.7282 L12.1861 7.2962 L13.6901 7.2962 L13.6901 12.8961 L12.4261 12.8961 L12.4261 9.5281 L11.346 12.2402 L10.3301 12.2401 L9.2501 9.5202 L9.2501 12.8962 L7.9861 12.8962 Z M13.8663 12.8962 L15.8984 7.2961 L17.3464 7.2961 L19.3864 12.8961 L18.0504 12.8962 L17.6584 11.7361 L15.5784 11.7362 L15.1784 12.8962 L13.8663 12.8962 Z M15.9304 10.7281 L17.3144 10.7282 L16.6104 8.6881 L15.9304 10.7281 Z M19.6854 12.8961 L19.6855 7.2962 L21.8215 7.2961 C22.2055 7.2961 22.5441 7.3628 22.8374 7.4962 C23.1308 7.6295 23.3601 7.8214 23.5255 8.0721 C23.6908 8.3175 23.7734 8.6108 23.7734 8.9521 C23.7734 9.3254 23.6721 9.6375 23.4694 9.8882 C23.2667 10.1388 22.9868 10.3175 22.6294 10.4242 L24.1575 12.8962 L22.7015 12.8962 L21.3654 10.6161 L20.9495 10.6161 L20.9494 12.8961 L19.6854 12.8961 Z M20.9494 9.5441 L21.7974 9.5441 C21.9948 9.5442 22.1414 9.5148 22.2375 9.4561 C22.3388 9.3921 22.4081 9.3148 22.4455 9.2241 C22.4828 9.1334 22.5015 9.0428 22.5014 8.9521 C22.5014 8.8615 22.4828 8.7734 22.4455 8.6881 C22.4081 8.5975 22.3388 8.5228 22.2375 8.4642 C22.1414 8.4054 21.9947 8.3761 21.7974 8.3761 L20.9494 8.3761 L20.9494 9.5441 Z",
							id: `${__svgrId}-MAR`,
							style: { fill: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.9419,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.1461",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateMar;
